<template>
    <div v-if="type !== 'large'" class="event-card" :class="type">
        <router-link
          :to="{
            name: 'EventProfile',
            params: {
              slug: event.slug
            }
          }"
        >
          <div class="card-image h-3/5 relative">
            <img
              :src="getImageUrl(event)"
              :alt="nameFormatted"
              class="lazyload main-image"
              @error="
                $event.target.src = require('@/assets/images/placeholder-event.svg')
              "
            />
            <img
              v-if="hasCulturalBonus(event, timezone)"
              :src="require('@/assets/images/cultural-bonus.png')"
              :alt="$t('wegow.altIcon')"
              class="cultural-icon absolute top-1.5 left-1.5 lazyload"
            />
            <div v-if="event.price || event.price === 0" class="price">
              <span class="font-museo-700 text-s align-middle">
                {{
                  formatCurrency(Number(event.price).toFixed(2), event.currency)
                }}
                <!-- TODO: revisar si es necesario el fixed -->
              </span>
            </div>
            <div
              v-if="
                event.cancelation_status !== 0 && event.cancelation_status !== 4
              "
              class="event-status-container"
            >
              {{ $t("wegow.events.status" + event.cancelation_status) }}
            </div>
          </div>
          <div class="card-info">
            <span class="text-xs">{{ eventDate }}</span>
            <h2 class="text-m text-left event-name">
              {{ nameFormatted }}
            </h2>
          </div>
      </router-link>
    </div>
    <div
      v-else-if="type === 'large'"
      class="event-card flex-1 large flex md:flex-row flex-col"
    >
      <div class="card-image relative">
        <router-link
          :to="{
            name: 'EventProfile',
            params: {
              slug: event.slug
            }
          }"
          class="h-full"
        >
            <img
              :src="getImageUrl(event)"
              :alt="event.title"
              class="main-image"
              loading="lazy"
              @error="
                $event.target.src = require('@/assets/images/placeholder-event.svg')
              "
            />
        </router-link>
      </div>
  
      <div class="card-info flex-1">
        <div class="info flex flex-col justify-between">
          <div class="header flex flex-col">
            <router-link
              :to="{
                name: 'EventProfile',
                params: {
                  slug: event.slug
                }
              }"
            >
                <span class="font-museo-500 text-m" v-html="nameFormatted"></span>
              
            </router-link>
  
            <router-link
              :to="{
                name: 'VenueProfile',
                params: {
                  slug: event.venue.slug
                }
              }"
              :blank="openExternal"
            >
                <span class="font-museo-500 text-s text-color-topaz-light"
                  >{{ event.venue.name }}
                  {{ event.city?.name ? "-" + event.city.name : "" }}</span
                >
            </router-link>
          </div>
          <div
            class="date-info text-color-gray font-museo-500 text-s flex flex-row gap-x-6 md:mt-0 mt-4 flex-wrap"
          >
            <div class="day">
              <img
                :src="require('@/assets/images/ic-calendar.svg')"
                :alt="$t('wegow.altIcon')"
                class="close-icon cursor-pointer"
              />
              <span>{{ eventDate }}</span>
            </div>
            <div class="hour">
              <img
                :src="require('@/assets/images/ic-clock.svg')"
                :alt="$t('wegow.altIcon')"
                class="close-icon cursor-pointer"
              />
              <span>{{ eventHour }}</span>
            </div>
          </div>
        </div>
        <div
          class="payment flex md:flex-col flex-row justify-between text-right md:mt-0 mt-1"
        >
          <div
            v-if="event.price || event.price === 0"
            class="price font-museo-500"
          >
            {{ formatCurrency(Number(event.price).toFixed(2), event.currency) }}
          </div>
          <div v-if="event.enabled" class="purchase">
            <router-link
              :params="{
                name: 'PurchasePage',
                params: {
                  slug: event.slug
                }
              }"
              :blank="openExternal"
            >
                <wegow-button
                  id="square-banner"
                  background="opacity"
                  color="topaz-light"
                  size="xl"
                  type="button"
                  :text="$t('wegow.purchase.buy')"
                />
                <wegow-button
                  id="square-banner__purchase--cancel"
                  class="inline md:hidden"
                  background="opacity"
                  color="topaz-light"
                  size="base"
                  type="button"
                  :text="$t('wegow.purchase.buy')"
                />
            </router-link>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script setup>
import WegowButton from "@/components/forms/WegowButton";
// import WNavigation from "@/components/ui/WNavigation";
    
import { useEvent } from "@/composables/useEvent";
import { formatCurrency } from "@/plugins/currency";
import { formatLongDate, formatHour } from "@/plugins/date-formater";
import { computed, onMounted, toRefs, ref } from "vue";
import { useI18n } from "vue-i18n";
// import { useRoute } from "vue-router";
// import { useUser } from "@/composables/useUser";
import { defineProps, defineEmits } from 'vue';
  
const props = defineProps({
  event: {
    type: Object,
    required: true
  },
  type: {
    type: String,
    default: undefined
  },
  openExternal: {
    type: Boolean,
    default: false
  }
});
  
defineEmits("emptyAd");
  
const { event, type } = toRefs(props);
//   const route = useRoute();
//   const { selectedRegion } = useUser();
const { t } = useI18n();
const timezone = ref("Europe/Madrid");
const formatDate = (date, region) => {
  let infoDate = formatLongDate(date, region, event.value.attendance === 2);
  return t("wegow.date.dateFormat", infoDate);
};

const { hasCulturalBonus } = useEvent();

onMounted(async () => {
  timezone.value = (await Intl.DateTimeFormat())
    .resolvedOptions()
    .timeZone.trim();
  // if (props.event.add) {
  //   showAd.value = false;
  // }
});

const eventDate = computed(() =>
  // formatDate(event.value.start_date, selectedRegion())
  formatDate(event.value.start_date, 'es')
);
const eventHour = computed(() =>
  // formatHour(event.value.start_date, route.params.region)
  formatHour(event.value.start_date, 'es')
);

const getImageUrl = element =>
  element?.thumbnails?.s_cd || require("@/assets/images/placeholder-event.svg");

const nameFormatted = computed(() => {
  let title = event.value.title;
  const replaceStrings = [
    t("wegow.headerDetails.start"),
    t("wegow.headerDetails.startStreaming"),
    t("wegow.headerDetails.in", { city: event.value.city?.name || "" })
  ];
  const replace = new RegExp(`(${replaceStrings.join(")|(")})`);
  return title?.replace(replace, "");
});
</script>

<style lang="scss" scoped>
.event-card-navigation {
  display: flex;
  flex-direction: column;
}
.payment {
  .price {
    font-size: 20px;
    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
  }
}

.people-icon {
  width: 23px;
}
.event-card:not(.large) {
  width: 280px;
  max-height: 276px;
  height: auto;
  aspect-ratio: 280/276;
  border-radius: 5px;
  overflow: hidden;
  &.big {
    height: 326px;
    width: 33.3%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
  &.special .card-info {
    background-image: url("@/assets/images/event-linear-background.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .card-image {
    .main-image {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
    .cultural-icon {
      width: 32px;
      height: 30px;
    }
    .price {
      @apply flex justify-center items-center;
      min-width: 80px;
      height: 42px;
      position: absolute;
      right: 0;
      top: 10px;
      background: $backgroundPrice;
      color: $colorPrice;
      opacity: 80%;
      padding: 12px 6px;
    }
    .event-status-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 80px;
      height: 42px;
      position: absolute;
      right: 0;
      bottom: 10px;
      background: $backgroundStatus;
      color: $colorStatus;
      opacity: 80%;
      padding: 12px 6px;
    }
  }
  .card-info {
    background: $backgroundCard;
    border-radius: 0px 0px 5px 5px;
    color: $textColor;

    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;

    padding: 20px;

    .event-title {
      font-weight: 800;
      font-size: 12px;
      line-height: 15px;
      text-align: left;
    }
    .event-name {
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
  }
}
.large {
  background-color: $backgroundCard;
  border-radius: 6px;
  overflow: hidden;
  min-width: 100%;
  @media screen and (min-width: 768px) {
    min-width: 650px;
  }
  .card-image {
    min-height: 160px;
    width: 160px;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 102px;
    }
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .card-info {
    @apply m-6 flex md:flex-row flex-col justify-between;
    .day,
    .hour {
      @apply flex flex-row gap-2 items-center;
    }
    .purchase {
      margin-top: auto;
    }
  }
}
</style>
<style lang="scss">
.large {
  small {
    color: $subtitleColor;
  }
}
</style>
